import { GET_STREAK_OFFERS_RESPONSE } from 'actions/streakOffers';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STREAK_OFFERS_RESPONSE:
      return action.response.userRewards;
    default:
      return state;
  }
};
